import { salesTargetService } from '../../helpers/services/salesTarget.service'
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'

export const state = {
  list: { data: [], pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 } },
  details: {},
  myProgress: null,
  allProgress: [],
  status: { list: true, detail: true, save: true },
}

export const SALES_TARGET_MODULE = 'salesTarget'

export const GET_ALL_SALES_TARGETS = 'getAllSalesTargets'
export const GET_SALES_TARGET = 'getSalesTarget'
export const CREATE_SALES_TARGET = 'createSalesTarget'
export const UPDATE_SALES_TARGET = 'updateSalesTarget'
export const DELETE_SALES_TARGET = 'deleteSalesTarget'
export const GET_MY_PROGRESS = 'getMyProgress'
export const GET_ALL_PROGRESS = 'getAllProgress'
export const GET_BY_AGENT = 'getByAgent'
export const GET_AGENT_DETAIL = 'getAgentDetail'
export const GET_MONTHLY_SUMMARY = 'getMonthlySummary'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'
const DETAIL_SUCCESS = 'detailSuccess'
const MY_PROGRESS_SUCCESS = 'myProgressSuccess'
const ALL_PROGRESS_SUCCESS = 'allProgressSuccess'

function mapRow(item) {
  const details = Array.isArray(item.details) ? item.details : []
  const totalTarget = details.reduce((s, d) => s + Number(d.target_amount || 0), 0)
  return {
    id: item.id,
    name: item.name,
    agent_code: item.agent_code,
    area_codes: Array.isArray(item.area_codes) ? item.area_codes : [],
    period_type: item.period_type,
    doc_types: Array.isArray(item.doc_types) ? item.doc_types : [],
    exclude_cancelled: !!item.exclude_cancelled,
    details,
    periods_count: details.length,
    total_target: totalTarget,
  }
}

export const actions = {
  [GET_ALL_SALES_TARGETS]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    salesTargetService.getAllSalesTargets(filter).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [GET_SALES_TARGET]({ commit }, { id }) {
    commit(REQUESTING, 'detail')
    return salesTargetService.getSalesTarget(id).then((r) => {
      commit(DETAIL_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [CREATE_SALES_TARGET]({ commit, dispatch }, { data, filter }) {
    commit(REQUESTING, 'save')
    return salesTargetService.createSalesTarget(data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.createX', [i18n.t('module.salesTarget')]))
      commit(SUCCESS); if (filter) dispatch(GET_ALL_SALES_TARGETS, { filter }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [UPDATE_SALES_TARGET]({ commit, dispatch }, { id, data, filter }) {
    commit(REQUESTING, 'save')
    return salesTargetService.updateSalesTarget(id, data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.salesTarget')]))
      commit(SUCCESS); if (filter) dispatch(GET_ALL_SALES_TARGETS, { filter }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [DELETE_SALES_TARGET]({ commit, dispatch }, { id, filter }) {
    return salesTargetService.deleteSalesTarget(id).then((r) => {
      commit(SUCCESS); if (filter) dispatch(GET_ALL_SALES_TARGETS, { filter }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [GET_MY_PROGRESS]({ commit }) {
    return salesTargetService.getMyProgress().then((r) => {
      commit(MY_PROGRESS_SUCCESS, r); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [GET_ALL_PROGRESS](_ctx, { params }) {
    return salesTargetService.getAllProgress(params)
  },
  [GET_BY_AGENT]() {
    return salesTargetService.getByAgent().catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [GET_AGENT_DETAIL](_ctx, { agentCode }) {
    return salesTargetService.getAgentDetail(agentCode).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [GET_MONTHLY_SUMMARY](_ctx, { year } = {}) {
    return salesTargetService.getMonthlySummary(year).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    const items = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? items.map(mapRow) : items
  },
  [DETAIL_SUCCESS](state, data) {
    state.details = data.data || {}
  },
  [MY_PROGRESS_SUCCESS](state, data) { state.myProgress = data.data || null },
  [ALL_PROGRESS_SUCCESS](state, data) { state.allProgress = data.data || [] },
  [FAILURE](state) { state.status = { list: true, detail: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, detail: true, save: true } },
}
